module.exports = __webpack_public_path__ + "static/media/team_5.5cfc194c.png";